// src/helpers/menu/modals/additionModal.ts
var getMainScreenDataCore = (entity, state, currentRelationsIds) => {
  const { currentMenu } = state.menu.selectedMode;
  const masterMenu = state.menu.masterMenu;
  const masterEntityIds = Object.keys(masterMenu[entity]);
  const currentMenuEntityIds = currentRelationsIds ? currentRelationsIds : Object.keys(currentMenu[entity]);
  const difference = masterEntityIds.filter(
    (id) => currentMenuEntityIds.indexOf(id) === -1
  );
  return difference;
};
var getDetailsScreenDataCore = (currentRelationsIds, wantedEntity, state, filterFunction) => {
  const _currentRelationId = (currentRelationsIds || []).map(
    (id) => id ? `${id}` : ""
  );
  const wantedEntityObject = state.menu.selectedMode.currentMenu[wantedEntity] || state.settings.selectedMode.currentSettings[wantedEntity];
  const wantedEntityIdsArray = Object.keys(wantedEntityObject);
  const difference = wantedEntityIdsArray.filter(
    (id) => _currentRelationId.indexOf(id) === -1
  );
  return filterFunction ? filterFunction(difference) : difference;
};
var getLocationsCore = (extraLocationIds = [], state, isSettingsAccessLocations) => {
  const loggedInUserPermittedLocations = isSettingsAccessLocations ? state.loggedInUser.settingsAccessLocations : state.loggedInUser.menuAccessLocations;
  const changeMassUpdateData = state.menu.changeMassUpdateData.data;
  const itemAddLocations = (changeMassUpdateData == null ? void 0 : changeMassUpdateData.locationIds) ? changeMassUpdateData.locationIds : [];
  const itemRemoveLocations = (changeMassUpdateData == null ? void 0 : changeMassUpdateData.removeLocationIds) ? changeMassUpdateData.removeLocationIds : [];
  const locations = [
    ...itemAddLocations,
    ...itemRemoveLocations,
    ...extraLocationIds
  ];
  const difference = locations && loggedInUserPermittedLocations.filter((id) => locations.indexOf(id) === -1);
  return difference || [];
};

export { getDetailsScreenDataCore, getLocationsCore, getMainScreenDataCore };
